import { SET_LOCALE_DATA } from './locale-actions';

const defaultState = {
    trans: null
};

/**
 * Participation Report Reducer
 *
 * Consumes PARTICIPATION_REPORT_RETRIEVED action
 *
 * @param {object} state the current state; may be undefined when application starts
 * @param {object} action, an object with a type and a payload
 * @returns {object} - current participation report info
 */
export default function (state = defaultState, action) {
    if (!action) return state;

    const { payload, type } = action;
    switch (type) {
    case SET_LOCALE_DATA: {
        return {
            ...payload.translations
        };
    }
    default:
        return state;
    }
}




// WEBPACK FOOTER //
// ./locale/locale-reducer.js